export default {
    open: "Antwoord nu",
    approve: "Nu goedkeuren",
    impersonation: {
        title: "Je bestelt namens «{name}»",
        cta: "Schakel terug naar mezelf",
    },
    "You have an unapproved orders": "U moet orders goedkeuren",
    "You have orders to approve": "U moet orders goedkeuren"
}